// Comprehensive airport database with IATA codes
export const airportDatabase = [
  // North America
  { iata: 'JFK', name: 'John F. Kennedy International Airport', city: 'New York', country: 'United States', region: 'North America' },
  { iata: 'LAX', name: 'Los Angeles International Airport', city: 'Los Angeles', country: 'United States', region: 'North America' },
  { iata: 'ORD', name: "O\'Hare International Airport", city: 'Chicago', country: 'United States', region: 'North America' },
  { iata: 'DFW', name: 'Dallas/Fort Worth International Airport', city: 'Dallas', country: 'United States', region: 'North America' },
  { iata: 'DEN', name: 'Denver International Airport', city: 'Denver', country: 'United States', region: 'North America' },
  { iata: 'ATL', name: 'Hartsfield-Jackson Atlanta International Airport', city: 'Atlanta', country: 'United States', region: 'North America' },
  { iata: 'SEA', name: 'Seattle-Tacoma International Airport', city: 'Seattle', country: 'United States', region: 'North America' },
  { iata: 'SFO', name: 'San Francisco International Airport', city: 'San Francisco', country: 'United States', region: 'North America' },
  { iata: 'LAS', name: 'McCarran International Airport', city: 'Las Vegas', country: 'United States', region: 'North America' },
  { iata: 'MIA', name: 'Miami International Airport', city: 'Miami', country: 'United States', region: 'North America' },
  { iata: 'BOS', name: 'Logan International Airport', city: 'Boston', country: 'United States', region: 'North America' },
  { iata: 'YYZ', name: 'Toronto Pearson International Airport', city: 'Toronto', country: 'Canada', region: 'North America' },
  { iata: 'YVR', name: 'Vancouver International Airport', city: 'Vancouver', country: 'Canada', region: 'North America' },
  
  // Europe
  { iata: 'LHR', name: 'Heathrow Airport', city: 'London', country: 'United Kingdom', region: 'Europe' },
  { iata: 'CDG', name: 'Charles de Gaulle Airport', city: 'Paris', country: 'France', region: 'Europe' },
  { iata: 'FRA', name: 'Frankfurt Airport', city: 'Frankfurt', country: 'Germany', region: 'Europe' },
  { iata: 'AMS', name: 'Amsterdam Airport Schiphol', city: 'Amsterdam', country: 'Netherlands', region: 'Europe' },
  { iata: 'MAD', name: 'Madrid-Barajas Airport', city: 'Madrid', country: 'Spain', region: 'Europe' },
  { iata: 'FCO', name: 'Leonardo da Vinci–Fiumicino Airport', city: 'Rome', country: 'Italy', region: 'Europe' },
  { iata: 'MUC', name: 'Munich Airport', city: 'Munich', country: 'Germany', region: 'Europe' },
  { iata: 'ZUR', name: 'Zurich Airport', city: 'Zurich', country: 'Switzerland', region: 'Europe' },
  { iata: 'VIE', name: 'Vienna International Airport', city: 'Vienna', country: 'Austria', region: 'Europe' },
  { iata: 'ARN', name: 'Stockholm Arlanda Airport', city: 'Stockholm', country: 'Sweden', region: 'Europe' },
  
  // Asia
  { iata: 'NRT', name: 'Narita International Airport', city: 'Tokyo', country: 'Japan', region: 'Asia' },
  { iata: 'HND', name: 'Haneda Airport', city: 'Tokyo', country: 'Japan', region: 'Asia' },
  { iata: 'ICN', name: 'Incheon International Airport', city: 'Seoul', country: 'South Korea', region: 'Asia' },
  { iata: 'PEK', name: 'Beijing Capital International Airport', city: 'Beijing', country: 'China', region: 'Asia' },
  { iata: 'PVG', name: 'Shanghai Pudong International Airport', city: 'Shanghai', country: 'China', region: 'Asia' },
  { iata: 'HKG', name: 'Hong Kong International Airport', city: 'Hong Kong', country: 'Hong Kong', region: 'Asia' },
  { iata: 'SIN', name: 'Singapore Changi Airport', city: 'Singapore', country: 'Singapore', region: 'Asia' },
  { iata: 'BKK', name: 'Suvarnabhumi Airport', city: 'Bangkok', country: 'Thailand', region: 'Asia' },
  { iata: 'KUL', name: 'Kuala Lumpur International Airport', city: 'Kuala Lumpur', country: 'Malaysia', region: 'Asia' },
  { iata: 'DEL', name: 'Indira Gandhi International Airport', city: 'Delhi', country: 'India', region: 'Asia' },
  { iata: 'BOM', name: 'Chhatrapati Shivaji Maharaj International Airport', city: 'Mumbai', country: 'India', region: 'Asia' },
  
  // Middle East
  { iata: 'DXB', name: 'Dubai International Airport', city: 'Dubai', country: 'United Arab Emirates', region: 'Middle East' },
  { iata: 'DOH', name: 'Hamad International Airport', city: 'Doha', country: 'Qatar', region: 'Middle East' },
  { iata: 'AUH', name: 'Abu Dhabi International Airport', city: 'Abu Dhabi', country: 'United Arab Emirates', region: 'Middle East' },
  { iata: 'IST', name: 'Istanbul Airport', city: 'Istanbul', country: 'Turkey', region: 'Middle East' },
  
  // Oceania
  { iata: 'SYD', name: 'Sydney Kingsford Smith Airport', city: 'Sydney', country: 'Australia', region: 'Oceania' },
  { iata: 'MEL', name: 'Melbourne Airport', city: 'Melbourne', country: 'Australia', region: 'Oceania' },
  { iata: 'AKL', name: 'Auckland Airport', city: 'Auckland', country: 'New Zealand', region: 'Oceania' },
  
  // Africa
  { iata: 'CPT', name: 'Cape Town International Airport', city: 'Cape Town', country: 'South Africa', region: 'Africa' },
  { iata: 'JNB', name: 'O. R. Tambo International Airport', city: 'Johannesburg', country: 'South Africa', region: 'Africa' },
  { iata: 'CAI', name: 'Cairo International Airport', city: 'Cairo', country: 'Egypt', region: 'Africa' },
  
  // South America
  { iata: 'GRU', name: 'São Paulo–Guarulhos International Airport', city: 'São Paulo', country: 'Brazil', region: 'South America' },
  { iata: 'EZE', name: 'Ezeiza International Airport', city: 'Buenos Aires', country: 'Argentina', region: 'South America' },
  { iata: 'BOG', name: 'El Dorado International Airport', city: 'Bogotá', country: 'Colombia', region: 'South America' },
  { iata: 'LIM', name: 'Jorge Chávez International Airport', city: 'Lima', country: 'Peru', region: 'South America' },
  { iata: 'SCL', name: 'Comodoro Arturo Merino Benítez International Airport', city: 'Santiago', country: 'Chile', region: 'South America' }
];

// Search function to find airports based on query
export const searchAirports = (query, limit = 10) => {
  if (!query || query?.length < 2) return [];
  
  const searchTerm = query?.toLowerCase()?.trim();
  
  return airportDatabase
    ?.filter(airport => 
      airport?.iata?.toLowerCase()?.includes(searchTerm) ||
      airport?.name?.toLowerCase()?.includes(searchTerm) ||
      airport?.city?.toLowerCase()?.includes(searchTerm) ||
      airport?.country?.toLowerCase()?.includes(searchTerm)
    )
    ?.sort((a, b) => {
      // Prioritize exact IATA code matches
      if (a?.iata?.toLowerCase() === searchTerm) return -1;
      if (b?.iata?.toLowerCase() === searchTerm) return 1;
      
      // Then prioritize city matches
      if (a?.city?.toLowerCase()?.startsWith(searchTerm)) return -1;
      if (b?.city?.toLowerCase()?.startsWith(searchTerm)) return 1;
      
      // Finally sort alphabetically by city
      return a?.city?.localeCompare(b?.city);
    })
    ?.slice(0, limit);
};

// Get airport by IATA code
export const getAirportByCode = (iataCode) => {
  return airportDatabase?.find(airport => 
    airport?.iata?.toLowerCase() === iataCode?.toLowerCase()
  );
};

// Format airport display text
export const formatAirportDisplay = (airport) => {
  if (!airport) return '';
  return `${airport?.city} (${airport?.iata}) - ${airport?.name}`;
};

// Extract IATA code from formatted string
export const extractIataCode = (formattedString) => {
  const match = formattedString?.match(/\(([A-Z]{3})\)/);
  return match ? match?.[1] : null;
};

export default {
  airportDatabase,
  searchAirports,
  getAirportByCode,
  formatAirportDisplay,
  extractIataCode
};